export class ConfirmationModalConfig {

  content: string;
  cancel: string;
  confirm: string;
  title: string;
  closed: (value: any) => void;

  constructor(
    content?: string,
    cancel?: string,
    confirm?: string,
    title?: string,
    closed?: (value: any) => void
  ) {
    this.content = content;
    this.cancel = cancel;
    this.confirm = confirm;
    this.title = title;
    this.closed = closed;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/confirmation-modal/confirmation-modal-config.ts